// // // final

// import React from "react";
// import desktopIcon from "../../assets/images/desktopIcon.png";



// function TherapyRoomCard({
//   image,
//   title,
//   description,
//   accessibility,
//   style,
//   usage,
//   available,
//   isComingSoon,
//   onEnterClick,
//   online, // Online status
//   showSuggestedUsage, // Preserve existing usage functionality
// }) {
//   return (
//     <div
//       className="bg-black text-white rounded-3xl shadow-lg p-6 flex flex-col mx-auto w-full max-w-[500px] md:max-w-[600px] lg:max-w-[700px] xl:max-w-[800px] h-auto"
//       style={{
//         position: "relative", // Ensure badge positions correctly
//         overflow: "visible",  // Prevent clipping
//       }}
//     >
//       {/* Online Badge */}
//       {online && (
//         <div
//           className="flex items-center bg-[#D8F8FF] text-black text-sm px-3 py-1 rounded-full absolute"
//           style={{
//             top: "-15px", // Appear slightly outside the card
//             right: "10px", // Proper placement on the right
//             boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)", // Shadow for visibility
//             zIndex: 10, // Ensure it appears above other elements
//           }}
//         >
//           <span
//             className="bg-[#22AAEE] rounded-full w-3 h-3 mr-2"
//             style={{
//               display: "inline-block",
//             }}
//           ></span>
//           <span>Online</span>
//         </div>
//       )}

//       {/* Image Section */}
//       <img
//         src={image}
//         alt={title}
//         className="w-full h-48 object-cover rounded-lg mb-4"
//       />

//       {/* Title and Description Section */}
//       <div className="mb-4" style={{ minHeight: "120px" }}>
//         <h3
//           className="font-medium mb-2"
//           style={{ fontSize: "var(--font-size-title)" }}
//         >
//           {title}
//         </h3>
//         <p
//           className="font-medium"
//           style={{ fontSize: "var(--font-size-description)" }}
//         >
//           {description}
//         </p>
//       </div>

//       {/* Metadata Section */}
//       <div style={{ minHeight: "100px" }}>
//         {/* Accessibility */}
//         <p
//           className="font-medium mb-2 flex items-center"
//           style={{ fontSize: "var(--font-size-small)" }}
//         >
//           Accessibility | {accessibility}
//           <span
//             style={{
//               display: "inline-flex",
//               alignItems: "center",
//               marginLeft: "5px",
//             }}
//           >
//             <img
//               src={desktopIcon}
//               alt="Accessibility Icon"
//               style={{
//                 width: "18px",
//                 height: "18px",
//               }}
//             />
//           </span>
//         </p>

//         {/* Virtual Space Style */}
//         <p
//           className="font-medium mb-2"
//           style={{ fontSize: "var(--font-size-small)" }}
//         >
//           Virtual Space Style | {style}
//         </p>

//         {/* Suggested Usage */}
//         {showSuggestedUsage && (
//           <p
//             className="font-medium"
//             style={{ fontSize: "var(--font-size-small)" }}
//           >
//             Suggested Usage | {usage}
//           </p>
//         )}
//       </div>

//       {/* Button Section */}
//       <div className="w-full flex justify-center mt-2">
//         <button
//           onClick={() => {
//             if (available) {
//               onEnterClick();
//             }
//           }}
//           disabled={!available}
//           className={`font-bold rounded-full transition w-[250px] sm:w-[300px] md:w-[350px] ${
//             available
//               ? "bg-[#D8F8FF] text-black hover:bg-[#22AAEE] hover:text-white"
//               : "bg-gray-500 cursor-not-allowed"
//           }`}
//           style={{
//             padding: "12px 50px",
//             fontSize: "var(--font-size-button)",
//             whiteSpace: "nowrap",
//           }}
//         >
//           {available
//             ? "ENTER SESSION"
//             : isComingSoon
//             ? "COMING SOON"
//             : "UNAVAILABLE"}
//         </button>
//       </div>
//     </div>
//   );
// }


// export default TherapyRoomCard;



// latest

// import React from "react";
// import desktopIcon from "../../assets/images/desktopIcon.png";



// function TherapyRoomCard({
//   image,
//   title,
//   description,
//   accessibility,
//   style,
//   usage,
//   available,
//   isComingSoon,
//   onEnterClick,
//   online, // Online status
//   showSuggestedUsage, // Preserve existing usage functionality
//   hoursLeft,
// }) {
//   return (
//     <div
//       className="bg-black text-white rounded-3xl shadow-lg p-6 flex flex-col mx-auto w-full max-w-[500px] md:max-w-[600px] lg:max-w-[700px] xl:max-w-[800px] h-auto"
//       style={{
//         position: "relative", // Ensure badge positions correctly
//         overflow: "visible",  // Prevent clipping
//       }}
//     >
//       {/* Online Badge */}
//       {online && (
//         <div
//           className="flex items-center bg-[#D8F8FF] text-black text-sm px-3 py-1 rounded-full absolute"
//           style={{
//             top: "-15px", // Appear slightly outside the card
//             right: "10px", // Proper placement on the right
//             boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)", // Shadow for visibility
//             zIndex: 10, // Ensure it appears above other elements
//           }}
//         >
//           <span
//             className="bg-[#22AAEE] rounded-full w-3 h-3 mr-2"
//             style={{
//               display: "inline-block",
//             }}
//           ></span>
//           <span>Online</span>
//         </div>
//       )}

//       {/* Image Section */}
//       <img
//         src={image}
//         alt={title}
//         className="w-full h-48 object-cover rounded-lg mb-4"
//       />

//       {/* Title and Description Section */}
//       <div className="mb-4" style={{ minHeight: "120px" }}>
//         <h3
//           className="font-medium mb-2"
//           style={{ fontSize: "var(--font-size-title)" }}
//         >
//           {title}
//         </h3>
//         <p
//           className="font-medium"
//           style={{ fontSize: "var(--font-size-description)" }}
//         >
//           {description}
//         </p>
//       </div>

//       {/* Metadata Section */}
//       <div style={{ minHeight: "100px" }}>
//         {/* Accessibility */}
//         <p
//           className="font-medium mb-2 flex items-center"
//           style={{ fontSize: "var(--font-size-small)" }}
//         >
//           Accessibility | {accessibility}
//           <span
//             style={{
//               display: "inline-flex",
//               alignItems: "center",
//               marginLeft: "5px",
//             }}
//           >
//             <img
//               src={desktopIcon}
//               alt="Accessibility Icon"
//               style={{
//                 width: "18px",
//                 height: "18px",
//               }}
//             />
//           </span>
//         </p>

//         {/* Virtual Space Style */}
//         <p
//           className="font-medium mb-2"
//           style={{ fontSize: "var(--font-size-small)" }}
//         >
//           Virtual Space Style | {style}
//         </p>

//         {/* Suggested Usage */}
//         {showSuggestedUsage && (
//           <p
//             className="font-medium"
//             style={{ fontSize: "var(--font-size-small)" }}
//           >
//             Suggested Usage | {usage}
//           </p>
//         )}

//         {/* Hours Left */}
//         {hoursLeft > 0 && (
//           <p
//             className="font-medium text-[#22AAEE] mt-2"
//             style={{ fontSize: "var(--font-size-small)" }}
//           >
//             {hoursLeft} {hoursLeft === 1 ? "hour" : "hours"} left for this session
//           </p>
//         )}
//       </div>

//       {/* Button Section */}
//       <div className="w-full flex justify-center mt-2">
//         <button
//           onClick={() => {
//             if (available) {
//               onEnterClick();
//             }
//           }}
//           disabled={!available}
//           className={`font-bold rounded-full transition w-[250px] sm:w-[300px] md:w-[350px] ${
//             available
//               ? "bg-[#D8F8FF] text-black hover:bg-[#22AAEE] hover:text-white"
//               : "bg-gray-500 cursor-not-allowed"
//           }`}
//           style={{
//             padding: "12px 50px",
//             fontSize: "var(--font-size-button)",
//             whiteSpace: "nowrap",
//           }}
//         >
//           {available
//             ? "ENTER SESSION"
//             : isComingSoon
//             ? "COMING SOON"
//             : "UNAVAILABLE"}
//         </button>
//       </div>
//     </div>
//   );
// }


// export default TherapyRoomCard;

// test

// import React from "react";
// import desktopIcon from "../../assets/images/desktopIcon.png";

// function TherapyRoomCard({
//   image,
//   title,
//   description,
//   accessibility,
//   style,
//   usage,
//   available,
//   isComingSoon,
//   onEnterClick,
//   online, // Online status
//   showSuggestedUsage, // Preserve existing usage functionality
//   sessionStartTimeEST, // New prop for formatted session start time
// }) {
//   return (
//     <div
//       className="bg-black text-white rounded-3xl shadow-lg p-6 flex flex-col mx-auto w-full max-w-[500px] md:max-w-[600px] lg:max-w-[700px] xl:max-w-[800px] h-auto"
//       style={{
//         position: "relative", // Ensure badge positions correctly
//         overflow: "visible", // Prevent clipping
//       }}
//     >
//       {/* Online Badge */}
//       {online && (
//         <div
//           className="flex items-center bg-[#D8F8FF] text-black text-sm px-3 py-1 rounded-full absolute"
//           style={{
//             top: "-15px", // Appear slightly outside the card
//             right: "10px", // Proper placement on the right
//             boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)", // Shadow for visibility
//             zIndex: 10, // Ensure it appears above other elements
//           }}
//         >
//           <span
//             className="bg-[#22AAEE] rounded-full w-3 h-3 mr-2"
//             style={{
//               display: "inline-block",
//             }}
//           ></span>
//           <span>Online</span>
//         </div>
//       )}

//       {/* Image Section */}
//       <img
//         src={image}
//         alt={title}
//         className="w-full h-48 object-cover rounded-lg mb-4"
//       />

//       {/* Title and Description Section */}
//       <div className="mb-4" style={{ minHeight: "120px" }}>
//         <h3
//           className="font-medium mb-2"
//           style={{ fontSize: "var(--font-size-title)" }}
//         >
//           {title}
//         </h3>
//         <p
//           className="font-medium"
//           style={{ fontSize: "var(--font-size-description)" }}
//         >
//           {description}
//         </p>
//       </div>

//       {/* Metadata Section */}
//       <div style={{ minHeight: "100px" }}>
//         {/* Accessibility */}
//         <p
//           className="font-medium mb-2 flex items-center"
//           style={{ fontSize: "var(--font-size-small)" }}
//         >
//           Accessibility | {accessibility}
//           <span
//             style={{
//               display: "inline-flex",
//               alignItems: "center",
//               marginLeft: "5px",
//             }}
//           >
//             <img
//               src={desktopIcon}
//               alt="Accessibility Icon"
//               style={{
//                 width: "18px",
//                 height: "18px",
//               }}
//             />
//           </span>
//         </p>

//         {/* Virtual Space Style */}
//         <p
//           className="font-medium mb-2"
//           style={{ fontSize: "var(--font-size-small)" }}
//         >
//           Virtual Space Style | {style}
//         </p>

//         {/* Suggested Usage */}
//         {showSuggestedUsage && (
//           <p
//             className="font-medium"
//             style={{ fontSize: "var(--font-size-small)" }}
//           >
//             Suggested Usage | {usage}
//           </p>
//         )}

//         {/* Session Start Time */}
//         <p
//           className="font-medium text-[#FFD700] mt-2"
//           style={{ fontSize: "var(--font-size-small)" }}
//         >
//           Session Start Time: {sessionStartTimeEST} EST
//         </p>
//       </div>

//       {/* Button Section */}
//       <div className="w-full flex justify-center mt-2">
//         <button
//           onClick={() => {
//             if (available) {
//               onEnterClick();
//             }
//           }}
//           disabled={!available}
//           className={`font-bold rounded-full transition w-[250px] sm:w-[300px] md:w-[350px] ${
//             available
//               ? "bg-[#D8F8FF] text-black hover:bg-[#22AAEE] hover:text-white"
//               : "bg-gray-500 cursor-not-allowed"
//           }`}
//           style={{
//             padding: "12px 50px",
//             fontSize: "var(--font-size-button)",
//             whiteSpace: "nowrap",
//           }}
//         >
//           {available
//             ? "ENTER SESSION"
//             : isComingSoon
//             ? "COMING SOON"
//             : "UNAVAILABLE"}
//         </button>
//       </div>
//     </div>
//   );
// }

// export default TherapyRoomCard;


import React, { useState } from "react";
import desktopIcon from "../../assets/images/desktopIcon.png";
import starIcon from "../../assets/images/star.png";

function TherapyRoomCard({
  image,
  title,
  description,
  accessibility,
  style,
  usage,
  available,
  isComingSoon,
  onEnterClick,
  online, 
  showSuggestedUsage, 
  sessionStartTimeEST, 
  isSelected, 
  onSelect,
  userType,
}) {
  const [isHovered, setIsHovered] = useState(false);
  const [isStarHovered, setIsStarHovered] = useState(false);

  return (
    <div
      className={`bg-black text-white rounded-3xl shadow-lg p-6 flex flex-col mx-auto w-full max-w-[500px] md:max-w-[600px] lg:max-w-[700px] xl:max-w-[800px] h-auto transition-all duration-300 border-2 cursor-pointer ${
        isComingSoon
          ? " cursor-not-allowed border-[4px] border-transparent"
        
        :isSelected
          ? " border-[8px] border-[#22AAEE]" 
          : isHovered
          ? " border-[8px] border-[#22AAEE]" 
          : "border-transparent"
      }`}
      
      style={{
        position: "relative", 
        overflow: "visible", 
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={onSelect} 
    >

      {/* Star Icon for Selected State */}
      {/* {isSelected && (
  <img
    src={starIcon}
    alt="Selected"
    className="absolute top-0 left-0 w-13 h-12 z-20"
    style={{
      transform: "translate(-45%, -65%)", 
    }}
  />
)} */}

{/* Star Icon for Selected State */}
{isSelected && (
        <div
          className="absolute top-0 left-0 z-20"
          style={{
            transform: "translate(-45%, -65%)",
          }}
          onMouseEnter={() => setIsStarHovered(true)}
          onMouseLeave={() => setIsStarHovered(false)}
        >
          <img src={starIcon} alt="Selected" className="w-13 h-12" />

          {/* Description on Hover - Different for Client and Therapist */}
          {isStarHovered && (
            <span
              className="absolute bg-white text-black text-xs px-2 py-2 rounded-xl shadow-lg"
              style={{
                top: "-20px",
                left: "80%",
                whiteSpace: "nowrap",
                zIndex: 30,
              }}
            >
              {userType === "Client"
                ? "Your preferred space"
                : "Client's preferred space"}
            </span>
          )}
        </div>
      )}







      {/* Online Badge */}
      {online && (
        <div
          className="flex items-center bg-[#D8F8FF] text-black text-sm px-3 py-1 rounded-full absolute"
          style={{
            top: "-15px", // Appear slightly outside the card
            right: "10px", // Proper placement on the right
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)", // Shadow for visibility
            zIndex: 10, // Ensure it appears above other elements
          }}
        >
          <span
            className="bg-[#22AAEE] rounded-full w-3 h-3 mr-2"
            style={{
              display: "inline-block",
            }}
          ></span>
          <span>Online</span>
        </div>
      )}

      {/* Image Section */}
      <img
        src={image}
        alt={title}
        className="w-full h-48 object-cover rounded-lg mb-4"
      />

      {/* Title and Description Section */}
      <div className="mb-4" style={{ minHeight: "120px" }}>
        <h3
          className="font-medium mb-2"
          style={{ fontSize: "var(--font-size-title)" }}
        >
          {title}
        </h3>
        <p
          className="font-medium"
          style={{ fontSize: "var(--font-size-description)" }}
        >
          {description}
        </p>
      </div>

      {/* Metadata Section */}
<div style={{ minHeight: "100px" }}>
  {/* Accessibility */}
  <p
    className="font-medium mb-2 flex items-center"
    style={{ fontSize: "var(--font-size-small)" }}
  >
    Accessibility | {accessibility}
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        marginLeft: "5px",
      }}
    >
      <img
        src={desktopIcon}
        alt="Accessibility Icon"
        style={{
          width: "18px",
          height: "18px",
        }}
      />
    </span>
  </p>

  {/* Virtual Space Style */}
  <p
    className="font-medium mb-2"
    style={{ fontSize: "var(--font-size-small)" }}
  >
    Virtual Space Style | {style}
  </p>

  {/* Session Start Time */}
  {sessionStartTimeEST && (
    <p
      className="font-medium text-[#22AAEE] mt-2"
      style={{ fontSize: "var(--font-size-small)" }}
    >
      Session Start Time: {sessionStartTimeEST}
    </p>
  )}
</div>


      {/* Button Section */}
      <div className="w-full flex justify-center mt-2">
        <button
          onClick={() => {
            if (available) {
              onEnterClick();
            }
          }}
          disabled={!available}
          className={`font-bold rounded-full transition w-[250px] sm:w-[300px] md:w-[350px] ${
            available
              ? "bg-[#D8F8FF] text-black hover:bg-[#22AAEE] hover:text-white"
              : "bg-gray-500 cursor-not-allowed"
          }`}
          style={{
            padding: "12px 50px",
            fontSize: "var(--font-size-button)",
            whiteSpace: "nowrap",
            
          }}
        >
          {available
            ? "ENTER SESSION"
            : isComingSoon
            ? "COMING SOON"
            : "UNAVAILABLE"}
        </button>
      </div>



      

    </div>
  );
}

export default TherapyRoomCard;



